import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomePage } from '../home/home.page';
import { MenuPage } from '../menu/menu.page';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { Location } from '@angular/common';

@Component({
	selector: 'app-privacy',
	templateUrl: './privacy.page.html',
	styleUrls: ['privacy.page.scss'],
})
export class PrivacyPage {
	static url = 'privacy';
	filterValue: string = '';
	constructor(
		private repository: RepositoryService,
		private navigationService: NavigationService,
		private location: Location,
		private route: ActivatedRoute
	) {}

	ngOnInit() {
		this.filterValue = this.route.snapshot.queryParamMap.get('blank');
	}

	async goBack() {
		if (this.location) {
			this.location.back();
			return;
		}
		if (this.repository._order === null) {
			await this.navigationService.home();
		} else {
			await this.navigationService.menu();
		}
	}
	openCookieSettings() {
		if (window['CookieConsent'] && window['CookieConsent'].showSettings) {
			window['CookieConsent'].showSettings();
		}
	}
}
